import { useTranslation } from 'react-i18next';

import { useUser } from '~/api/user';
import { Container, Header } from '~/components';
import { useMediaQuery } from '~/hooks/useMediaQuery';
import { breakpoints } from '~/styles/media.css';

import { CommunityProfilesList } from './CommunityProfilesList';
import { NetworkInfoCards } from './NetworkInfoCards';
import { NetworkLocked } from './NetworkLocked';

export const NetworkOverview = () => {
  const { data: user } = useUser();

  const isMobile = useMediaQuery(breakpoints.small);

  const { t } = useTranslation(['community']);

  return (
    <>
      <Header.Root>
        <Header.Content title={t('community:header.title')} />
      </Header.Root>

      <Container>
        {user.communityProfile.enabled ? (
          <>
            {!isMobile && <NetworkInfoCards />}

            <CommunityProfilesList />
          </>
        ) : (
          <NetworkLocked />
        )}
      </Container>
    </>
  );
};
